import { __awaiter } from "tslib";
import $ from "jquery";
import { createRoot } from 'react-dom/client';
import React, { useState, useEffect } from 'react';
import SearchResultItem from "./SearchResultItem";
const axios = require('axios').default;
const SearchForm = ({ vars }) => {
    const [data, setData] = useState({
        node: ""
    });
    const [formData, setFormData] = useState({
        search: "",
    });
    const [attributes, setAttributes] = useState({
        locale: vars.locale,
        cities: [],
        dictionnary: {},
        results: [],
        resultsState: "empty"
    });
    const [isLoaded, setIsLoaded] = useState(Array.isArray(attributes.dictionnary));
    useEffect(() => {
        if (!isLoaded) {
            const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
                function getTranslations() {
                    let formData = new FormData();
                    formData.append("locale", attributes.locale);
                    return axios.post("/api/translations", formData).then((response) => {
                        if (response.status == 200) {
                            return response.data.translations;
                        }
                        else {
                            return [];
                        }
                    });
                }
                function getCities() {
                    let formData = new FormData();
                    formData.append("locale", attributes.locale);
                    return axios.post("/api/cities", formData).then((response) => {
                        if (response.status == 200) {
                            return response.data.cities;
                        }
                        else {
                            return [];
                        }
                    });
                }
                Promise.all([getTranslations(), getCities()])
                    .then(function (results) {
                    setAttributes(Object.assign(Object.assign({}, attributes), { dictionnary: results[0], cities: results[1] }));
                    setIsLoaded(true);
                });
            });
            fetchData();
        }
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);
    const l = (label) => {
        if (attributes.dictionnary[label] !== void 0) {
            return attributes.dictionnary[label];
        }
        return label;
    };
    const handleChange = (e) => {
        let value = e.target.value;
        let data = Object.assign({}, formData);
        data.search = value;
        setFormData(data);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        let postData = new FormData();
        postData.append("s", formData.search);
        axios.post("/api/search", postData).then((response) => {
            if (response.status == 200) {
                let data = response.data.results;
                setAttributes(Object.assign(Object.assign({}, attributes), { resultsState: "filled", results: data }));
                let node = (data.map((element, index) => {
                    return React.createElement(SearchResultItem, { key: `result-${index}`, vars: { item: element, cities: attributes.cities, l: l } });
                }));
                setData({ node: "" });
                setTimeout(() => {
                    setData({ node: node });
                }, 10);
            }
        });
    };
    if (!isLoaded)
        return (React.createElement("div", { className: "loader" }, "Chargement en cours..."));
    let results;
    if (attributes.resultsState == "filled") {
        let resultsItem = data.node;
        results = (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "state" },
                React.createElement("h3", null, l("searchResultTitle")),
                React.createElement("h4", null, attributes.results.length > 1 ?
                    l("searchResultsCount").replace("%s", attributes.results.length)
                    : l("searchResultCount").replace("%s", attributes.results.length))),
            React.createElement("div", { className: "results" }, resultsItem)));
    }
    const handleClose = (e) => {
        e.preventDefault();
        $("#main-header .actions > .search").removeClass("show");
        setFormData(Object.assign(Object.assign({}, formData), { search: "" }));
        setAttributes(Object.assign(Object.assign({}, attributes), { results: [], resultsState: "empty" }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `search-form` },
            React.createElement("div", null,
                React.createElement("a", { href: "#close-box", onClick: handleClose },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "11.261", height: "20.518", viewBox: "0 0 11.261 20.518" },
                        React.createElement("path", { d: "M293.677,430.672l-8.847-8.847,8.843-8.843", transform: "translate(-283.831 -411.568)", fill: "none", stroke: "#233dd5", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })))),
            React.createElement("form", { action: "", method: "post", onSubmit: handleSubmit },
                React.createElement("input", { id: "search", name: "s", type: "text", placeholder: l("search-placeholder"), autoComplete: "off", value: formData.search, onChange: handleChange }),
                React.createElement("button", null,
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30.414", height: "30.414", viewBox: "0 0 30.414 30.414" },
                        React.createElement("g", { transform: "translate(-291 -60.5)" },
                            React.createElement("path", { d: "M28.5,16.5a12,12,0,1,1-12-12,12,12,0,0,1,12,12Z", transform: "translate(287.5 57)", fill: "none", stroke: "#113cdd", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
                            React.createElement("path", { d: "M31.5,31.5l-6.525-6.525", transform: "translate(288.5 58)", fill: "none", stroke: "#113cdd", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })))))),
        React.createElement("div", { className: `search-results ${attributes.resultsState}` },
            React.createElement("div", null, attributes.resultsState != "empty" ? results : ""))));
};
$(document).ready(() => {
    const rootElement = document.getElementById("searchform");
    if ($(rootElement).length) {
        $("body").on("click", "#main-header .actions > .search > a", (e) => {
            e.preventDefault();
            $("#main-header .actions > .search").addClass("show");
        });
        const root = createRoot(rootElement);
        const vars = {
            locale: $(rootElement).attr("data-locale"),
        };
        root.render(React.createElement(SearchForm, { vars: vars }));
    }
});
